import React from "react";
import "./index.less";

class listOfThirdSDKGuanChe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // document.title = '第三方SDK清单慧管车';
    return (
      <div className="page_type_h5_select">
        <article id="listOfThirdSDKGuanChe">
          <h2 style={{ textAlign: "center" }}>第三方SDK清单</h2>
          <p>
            为保障慧管车APP相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方及关联方提供的软件开发包（SDK）实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。我们对接入的相关SDK在目录中列明。
          </p>
          <p>
            请注意，第三方SDK及关联方可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。
          </p>
          <h3>1、高德地图SDK</h3>
          <p>运营方：高德软件有限公司</p>
          <p>使用场景： 地图上显示车辆所在地点</p>
          <p>处理目的：为了实现地图展示、定位、搜索等服务</p>
          <p>
            收集个人信息：经纬度、设备信息【如IP
            地址、GNSS信息、网络类型、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息传感器信息（矢量、加速度、压力、方向、地磁）、设备信号强度信息】、设备标识信息（IDFA、OAID）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（设备品牌及型号、操作系统、运营商信息、屏幕分辨率）
          </p>
          <p>
            隐私政策链接：
            <a
              href="https://lbs.amap.com/pages/privacy/ "
              style={{ color: "blue" }}
            >
              https://lbs.amap.com/pages/privacy/
            </a>
          </p>
          <h3>2、高德定位SDK</h3>
          <p>运营方：高德软件有限公司</p>
          <p>使用场景： 地图上显示车辆所在地点</p>
          <p>处理目的：为了向用户提供定位服务</p>
          <p>
            收集个人信息：经纬度、设备信息【如IP
            地址、GNSS信息、网络类型、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息传感器信息（矢量、加速度、压力）、设备信号强度信息】、设备标识信息（IDFA、OAID）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（设备品牌及型号、操作系统、运营商信息、屏幕分辨率）
          </p>
          <p>
            隐私政策链接：
            <a
              href="https://lbs.amap.com/pages/privacy/"
              style={{ color: "blue" }}
            >
              https://lbs.amap.com/pages/privacy/
            </a>
          </p>
          <h3>3、友盟SDK</h3>
          <p>运营方：北京友盟网络科技有限公司</p>
          <p>使用场景： 统计用户点击行为等场景使用</p>
          <p>
            处理目的：基于设备信息用于生成脱敏的终端用户设备标识，以确保提供SDK服务；基于粗略位置用于区域维度的应用分析，提供地区数据报表
          </p>
          <p>
            收集个人信息类型：IMEI/MAC/AndroidID/OAID/IDFA/OpenUDID/GUID/SIM卡IMSI/ICCID/IP/SN
          </p>
          <p>
            隐私政策链接：
            <a
              href="https://www.umeng.com/page/policy"
              style={{ color: "blue" }}
            >
              https://www.umeng.com/page/policy
            </a>
          </p>
          <h3>4、Bugly SDK</h3>
          <p>运营方：深圳市腾讯计算机系统有限公司</p>
          <p>使用场景： 使用于统计应用崩溃统计场景</p>
          <p>处理目的：统计用户奔溃</p>
          <p>收集个人信息类型：设备信息、日志信息</p>
          <p>
            隐私政策链接：
            <a
              href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
              style={{ color: "blue" }}
            >
              https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56
            </a>
          </p>
          <h3>5、微信Open SDK</h3>
          <p>运营方：深圳市腾讯计算机系统有限公司</p>
          <p>使用场景： 分享账单</p>
          <p>处理目的：用户将账单分享微信</p>
          <p>
            收集个人信息类型：用户分享图片或内容、设备安装微信APP状态、设备型号信息
          </p>
          <p>
            隐私政策链接：
            <a
              href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
              style={{ color: "blue" }}
            >
              https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8
            </a>
          </p>
        </article>
      </div>
    );
  }
}

export default listOfThirdSDKGuanChe;



// WEBPACK FOOTER //
// ./src/staticPage/listOfThirdSDKGuanChe/index.js